import { render } from "./MobileLightingProduct.vue?vue&type=template&id=0bc22190&scoped=true"
const script = {}

import "./MobileLightingProduct.vue?vue&type=style&index=0&id=0bc22190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc22190"]])

export default __exports__